const cartItemTemplate = (item, childBundleProducts, isSoftBundleProduct) => {
  const itemTitle = (isSoftBundleProduct && item.properties?._soft_bundle_title)
    ? item.properties?._soft_bundle_title
    : item.product_title

  const itemURL = (isSoftBundleProduct && item.properties?._soft_bundle_url)
    ? item.properties?._soft_bundle_url
    : item.url

  return `
    <cart-item class="cart-item ${isSoftBundleProduct ? 'cart-item--soft-bundle' : ''}"
      data-cart-item
      data-key="${item.key}"
      data-id="${item.id}"
      data-product-id="${item.product_id}"
      ${isSoftBundleProduct ? 'data-cart-item-soft-bundle' : ''}
    >
      <a href="${itemURL}" class="cart-item__image-holder">
        ${
          (isSoftBundleProduct && item.properties?._soft_bundle_image)
            ? `<img src="${item.properties._soft_bundle_image}" width="800" height="800" loading="lazy" alt="Image of ${itemTitle}">`
            : (item.image || item.featured_image.url) ? `<img src="${Shopify.Image.getSizedImageUrl(item.image || item.featured_image.url, '800x')}" width="800" height="800" loading="lazy" alt="Image of ${itemTitle}">` : ''
        }
      </a>

      <div class="cart-item__info-holder">
        <a href="${itemURL}" class="cart-item__link">
          <h4 class="cart-item__title heading-5">${itemTitle}</h4>
        </a>

        ${!item.variant_title || isSoftBundleProduct ? '' : `<p class="cart-item__variant-title">${item.variant_title}</p>`}
        ${cartItemProperties(item)}
        ${cartItemDiscounts(item)}

        <button
          class="cart-item__sfl"
          type="button"
          data-save-for-later
          data-product-id="${item.product_id}"
          data-variant-id="${item.variant_id}"
          data-product-url="${window.location.origin}${item.url}"
        >
          <svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14" fill="none">
            <path d="M14.1186 3.73047C14.0746 3.37947 13.8976 2.14047 12.8116 1.22847C11.6116 0.220473 10.2006 0.364473 9.8706 0.407473C8.4176 0.600472 7.5526 1.79347 7.2626 2.16647C6.9716 1.79347 6.1076 0.600472 4.6546 0.407473C4.3246 0.364473 2.9136 0.220473 1.7136 1.22847C0.627597 2.14047 0.450597 3.37947 0.406597 3.73047C0.184597 5.48247 1.1986 6.74547 1.3866 6.97147L7.2626 12.7095C9.2216 10.7965 11.1796 8.88447 13.1386 6.97147C13.3266 6.74547 14.3406 5.48247 14.1186 3.73047Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="cart-item__sfl-add">
            Save for later
          </span>
          <span class="cart-item__sfl-added">
            Saved
          </span>
        </button>

        <div class="cart-item__quantity-and-price">
          <p class="cart-item__price ${item.original_line_price > item.final_line_price ? 'cart-item__price--sale' : ''}" data-price>
            ${
              isSoftBundleProduct
                ? bundleChildrenPrice(item, childBundleProducts)
                : cartItemPrice(item.final_price, item.original_price)
            }
          </p>
          ${quantitySelectorTemplate(item)}
        </div>

        <button class="cart-item__remove" data-remove-cart-item aria-label="Remove ${itemTitle} from cart">
          <span class="visuallyhidden">Remove</span>
          <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.38498 2.14502L1.79498 11.055H8.52499L8.935 2.14502H1.38498Z" stroke="#101B2A" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M0.424988 2.14502H9.89499" stroke="#101B2A" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.715 0.425034H6.60498" stroke="#101B2A" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.435 2.14502L3.715 0.425034" stroke="#101B2A" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.89499 2.14502L6.60498 0.425034" stroke="#101B2A" stroke-width="0.85" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        ${sellingPlanSelect(item)}

        ${childBundleProducts.length === 0 ? '' : `<div data-bundle-childen>${bundleChildrenDetails(item, childBundleProducts)}</div>`}
      </div>

      ${cartItemFinalSale(item)}
    </cart-item>
  `
}

const cartItemTemplateEmpty = (item, childBundleProducts) => {
  return `
    <cart-item class="cart-item hide"
      data-cart-item
      data-cart-item-empty
      data-key="${item.key}"
      data-id="${item.id}"
      data-product-id="${item.product_id}"
    >
    </cart-item>
  `
}

const cartItemPrice = (finalLinePrice, originalLinePrice = 0) => {
  return (originalLinePrice > finalLinePrice)
    ? `<s>${Shopify.formatMoney(originalLinePrice)}</s> ${Shopify.formatMoney(finalLinePrice)}`
    : Shopify.formatMoney(finalLinePrice)
}

const cartItemProperties = (item) => {
  if (
    typeof item.properties === 'undefined' ||
    !item.properties ||
    Object.keys(item.properties).length === 0
  ) { return '' }

  return `
    <ul class="cart-item__properties p--small">
      ${
        Object.keys(item.properties).map((property) => {
          if (property.charAt(0) === '_') { return '' }
          return `<li>${property}: ${item.properties[property]}</li>`
        }).join('')
      }
    </ul>
  `
}

const cartItemDiscounts = (item) => {
  if (item.discounts.length <= 0) { return '' }
  const discountTotal = item.discounts.reduce((total, discount) => {
    return total + discount.amount
  }, 0)
  if (discountTotal === 0) { return '' }

  return `
    <ul class="cart-item__discounts">
      ${item.discounts.map(discount => `<li>${discount.title}</li>`).join('')}
    </ul>
  `
}

const cartItemFinalSale = (item) => {
  if (
    typeof item.properties === 'undefined' ||
    !item.properties ||
    Object.keys(item.properties).length === 0 ||
    !item.properties['Final Sale Item']
  ) { return '' }
  return `<p class="cart-item__final-sale">Final Sale Item: ${Shopify.theme_settings.final_sale_message}</p>`
}

const bundleChildrenPrice = (item, bundleChildren) => {
  if (bundleChildren.length === 0) { return '$0' }
  const finalBundleChildrenPrice = bundleChildren.reduce((prev, cur) => prev + cur.final_line_price, 0)
  return Shopify.formatMoney(finalBundleChildrenPrice)
}

const bundleChildrenDetails = (item, bundleChildren) => {
  if (bundleChildren.length === 0) { return '' }

  return `
    <details class="cart-item__bundle-children" data-bundle-details>
      <summary>
        <span>
          ${window.theme.icons.plus}
          ${window.theme.icons.minus}
          ${window.theme.strings.bundledProducts}
        </span>

        <span>
          ${bundleChildrenPrice(item, bundleChildren)}
        </span>
      </summary>

      <ul>
        ${
          bundleChildren.map((childItem) => `
            <li>
              <span>
                ${childItem.product_title}
                ${!childItem.variant_title ? '' : `<br> <span class="p--small">${childItem.variant_title}</span>`}
              </span>

              <span>
                ${cartItemPrice(childItem.final_line_price)}
              </span>
            </li>
          `).join('')
        }
      </ul>
    </detials>
  `
}

const sellingPlanSelect = (item) => {
  try {
    const planOptionsString = item.properties?._selling_plan_options
    if (typeof planOptionsString === 'undefined' || !planOptionsString) { return '' }

    const planOptions = JSON.parse(planOptionsString.replace(/`/g, '"'))
    const sellingPlanCurrent = item.selling_plan_allocation?.selling_plan?.id
    if (!planOptions || planOptions.length === 0) { return '' }

    return `
      <dropdown-select class="cart-item__selling-plan-select">
        <select data-selling-plan-select>
          <option
            value
            ${!sellingPlanCurrent ? 'selected' : ''}
          >
            ${window.theme.strings.sellingPlanSingle}
          </option>
          ${
            planOptions.map(option => `
              <option
                value="${option.sellingPlan.id.split('SellingPlan/')[1]}"
                ${
                  option.sellingPlan.id.split('SellingPlan/')[1] === sellingPlanCurrent?.toString() && sellingPlanCurrent
                    ? 'selected'
                    : ''
                }
              >
                ${option.sellingPlan.name}
              </option>
            `).join('')
          }
        </select>
      </dropdown-select>
    `
  } catch (err) {
    console.error(err)
    return ''
  }
}

const quantitySelectorTemplate = (item) => {
  return `
    <quantity-selector>
      <div class="cart-item__quantity-selector quantity-selector">
        <button class="quantity-selector__btn" type="button"
          data-quantity-button
          data-action="minus"
          aria-label="Minus ${item.title.replace(/"/g, '&quot;')} Quantity"
        >&minus;</button>

        <input class="quantity-selector__input" type="number" name="quantity"
          data-quantity-input
          min="0"
          ${
            typeof item.properties?._inventory_quantity !== 'undefined' && item.properties?._inventory_quantity !== null
              ? `max="${parseInt(item.properties._inventory_quantity, 10)}"`
              : ''
          }
          value="${item.quantity}"
          aria-label="${item.title.replace(/"/g, '&quot;')} Quantity Input"
        >

        <button class="quantity-selector__btn " type="button"
          data-quantity-button
          data-action="plus"
          aria-label="Plus ${item.title.replace(/"/g, '&quot;')} Quantity"
        >&plus;</button>
      </div>
    </quantity-selector>
  `
}
